/**
 * Bridge between the axios response interceptor (which cannot use React hooks)
 * and the React tree (which owns notistack + routing).
 *
 * The axios interceptor in `apiClient.js` calls `emitMissingScope(detail)`
 * whenever the backend returns a 403 with body `{ error: "missing_scope", ... }`.
 * A top-level listener component mounted under <SnackbarProvider> subscribes
 * via `onMissingScope` and renders a uniform "Autorizar" snackbar.
 *
 * We deliberately avoid a circular dependency with React/notistack here —
 * this module only handles pub/sub of plain data.
 *
 * detail shape: {
 *   integration_id: number,
 *   required_scope: string,
 *   bundle_hint: string,
 * }
 */

const listeners = new Set();

export const emitMissingScope = (detail) => {
  listeners.forEach((fn) => {
    try {
      fn(detail);
    } catch (err) {
      // Never let a listener crash the interceptor chain
      // eslint-disable-next-line no-console
      console.error('missing_scope listener failed:', err);
    }
  });
};

export const onMissingScope = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
